import React from 'react';
import type { WidgetStrings } from '../../utils/i18n';
import { DEFAULT_WIDGET_STRINGS } from '../../utils/i18n';

interface TypingIndicatorProps {
  strings?: WidgetStrings;
}

const TypingIndicator = React.memo(function TypingIndicator({
  strings = DEFAULT_WIDGET_STRINGS,
}: TypingIndicatorProps) {
  return (
    <div
      className="flex items-start mb-4"
      role="status"
      aria-live="polite"
      aria-label={strings.agentTypingAria}
    >
      <div className="max-w-[80%] rounded-lg px-3 py-2 bg-white border border-gray-200">
        <span className="typing-dot" aria-hidden="true" />
        <span className="typing-dot" aria-hidden="true" />
        <span className="typing-dot" aria-hidden="true" />
      </div>
    </div>
  );
});

export default TypingIndicator;
